import { api } from "@/libs/api-client";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const unfollowUserSchema = z.object({
  followeeId: z.string(),
});

export type UnfollowUserInput = z.infer<typeof unfollowUserSchema>;

export const unfollowUser = createServerFn({ method: "POST" })
  .validator(unfollowUserSchema)
  .handler(async ({ data }) => {
    const response = await api.post("user/unfollow", {
      searchParams: {
        userId: data.followeeId,
      },
    });

    return response.ok;
  });
